/**
 * Store pour la gestion des templates des chartes graphiques de type image simple
 */

import { defineStore } from 'pinia';

import { useAbstractGraphicalLineTemplateStore } from '@stores/graphicalLineTemplate/abstractGraphicalLineTemplateStore';

export const useCarouselGraphicalLineTemplateStore = defineStore('carouselImageGraphicalLineTemplate', (() => {

    const {
        getTemplateList,
        getTemplateById,
        loadTemplateList,
        updateTemplate,
        removeTemplate,
        duplicateTemplate,
        resetTemplateList,
        refreshRestorationState,
        restorePreviousState,
        resetRestorationState,
        setTemplateList
    } = useAbstractGraphicalLineTemplateStore({
        templateType: 'CAROUSEL'
    });

    return {
        getTemplateList,
        getTemplateById,
        loadTemplateList,
        updateTemplate,
        removeTemplate,
        duplicateTemplate,
        resetTemplateList,
        refreshRestorationState,
        restorePreviousState,
        resetRestorationState,
        setTemplateList
    };
}));
